// import Swiper bundle with all modules installed
// import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import inView from 'in-view';



export default class {

    constructor(options) {

        // OPTIONS
        this.defaults = {
            $el: 				undefined,

            transition_on: 		0.8,
            transition_off: 	0.3,
            transition_x: 		10,
            startIndex:         'random',

            autoplay: 	 		true,
            time_autoplay: 		4000
       }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'stats_slideshow';

		// DOM ELEMENT !!!!!!!!!!
		// vars
		this.$el = this.options.$el;
		this.$doc = $(document);
		/*
		this.$win = $(window);		
		this.$html = $('html');
		this.$body = $( 'body' );
		*/


		// init!!!!
		this.init(true);
    }

	init( b ){

		//console.log( 'init  :: '  + this.namespace );
		this.initSlider( b );
		// this.onResize();
	}

	initSlider( b ){

		if ( b ){

			this.index = -1;
			this.slides = [];
			this.$el.find( '.stat-slide' ).each(  (i,el) => {
				this.slides[i]  = {
					$el  		: $(el),
					$num 		: $(el).find( '.stat-num'  ),
					$text 		: $(el).find( '.stat-txt'  ),
					$images 	: $(el).find( 'img' )
				};
			});
			this.active = true;
			this.options.startIndex === 'random' ? this.setRandomSlide() : this.setSlide(this.options.startIndex);
			this.$el.addClass( 'stats-slideshow-init' );
			
			this.timeout = -1;
		}

		this.addEvents( b );
	}

	
    addEvents( b ){

		if ( b ){
			this.$el.find( 'a.next' ).on( 'click', 	(e) => this.nextSlide(e) );
		}
		else{
			this.$el.find( 'a.next' ).off( 'click', (e) => this.nextSlide(e) );
		}
		
		this.attachEventsKeyBoard( b );
		//this.debounceResize(b);
    }

    setSlide(i){
		if ( !this.active  ){
			return;
		}
		this.active = false;
    	this.revealSlide( this.index, false );
    	this.revealSlide( i, true );
    }

    nextSlide(e){
    	if ( e ){
    		e.preventDefault();
    		this.setAutoplay( false  );
    	}
    	let i = this.index + 1;
    	if ( i >=  this.slides.length ){
    		i = 0;
    	}
    	this.setSlide( i  );
    }

    setRandomSlide(){
    	this.setSlide( Math.floor( Math.random()*this.slides.length ) );
    }

    revealSlide(i, b){
    	if ( i !== -1 ){
    		let slide = this.slides[i], t;
    		if ( b ){
     			this.index = i;

     			// fade in slide
    			gsap.fromTo( slide.$el, {opacity:0, x: this.options.transition_x},  {opacity:1, x:0, duration:this.options.transition_on/7, ease:'power.easeOut'});

    			t  = gsap.timeline({delay:this.options.transition_on/3});
    			
    			// images
    			t.from( slide.$images, {opacity:0, x: "random(-30, 30, 2)", y: "random(-30, 30, 2)",  scale:0.8, ease: 'power.easeOut', duration:this.options.transition_on, stagger:0.2 } );
    			
    			// number
    			t.from( slide.$num, {opacity:0, x:this.options.transition_x, duration:this.options.transition_on, ease:'power.easeOut' }, "-=" + this.options.transition_on );

    			// text
    			t.from( slide.$text, {x:this.options.transition_x, opacity:0, duration:this.options.transition_on, ease:'power.easeOut', onComplete:()=>this.onRevelComplete() }, "-=" + this.options.transition_on*2/3 );
    		}
    		else{

    			// fade out slide
    			gsap.to( slide.$el, {opacity:0, x: 0, duration:this.options.transition_off, ease:'power.easeOut'});
    		}
    	}
    }

    onRevelComplete(){
    	this.active = true;
    	this.setAutoplay(  true );
    }

    setAutoplay(b){
    	if ( this.options.autoplay ){

    		clearTimeout( this.timeout );

    		if ( b ){
	    		this.timeout  = setTimeout(()=>{
	    			this.nextSlide();
	    		}, this.options.time_autoplay)    			
    		}

    	}
    }

    attachEventsKeyBoard( b ){
		if ( b ){
			if  ( !this.events_keyboard_attach ){
				this.events_keyboard_attach =   true;      
				this.$doc.on( 'keydown' , (e) => {
					if ( !inView.is( this.$el[0] ) ){
						return;
					}
					if( e.which === 39 || e.which === 40 ){
						// right arrow or dn
						this.nextSlide(e);
					}
					/*
					else if ( e.which === 37 || e.which === 38 ){
						// left arrow or up
						this.nextSlide( false );
					}
					*/
				});
			}
		}
		else{
			this.$doc.off( 'keydown' );
			this.events_keyboard_attach =   false;
		}
    }

    /*
    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 117 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
    }
    */

    /*
    onResize(){
    }
	*/
    destroy(){
		this.init( false );
		this.setAutoplay( false );
		this.$el.removeData();
    }

}

